export function transformErrors(obj) {
    return Object.fromEntries(
        Object.entries(obj).map(([key, value]) => [key, { message: value[0] || '' }])
    );
}